import { Link } from "react-router-dom";
import { Calendar, Gauge, Fuel, Cog } from "lucide-react";
import { formatPrice, formatKm, resolveImage } from "@/lib/api";

export const CarCard = ({ car }) => {
    const img = car.afbeeldingen?.[0];
    return (
        <Link to={`/auto/${car.id}`} className="ucs-card block group overflow-hidden" data-testid={`car-card-${car.id}`}>
            <div className="aspect-[4/3] bg-slate-100 overflow-hidden relative">
                {img ? (
                    <img src={resolveImage(img)} alt={`${car.merk} ${car.model}`}
                         loading="lazy" decoding="async"
                         className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-slate-400 text-sm">Geen afbeelding</div>
                )}
                <div className="absolute top-3 left-3 bg-[#0E2C4D] text-white text-[10px] tracking-[0.2em] font-bold uppercase px-2.5 py-1.5">
                    {car.brandstof}
                </div>
            </div>
            <div className="p-5">
                <div className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#EC6A0A] mb-1">{car.merk}</div>
                <h3 className="text-lg font-bold text-[#0E2C4D] truncate" data-testid={`car-card-title-${car.id}`}>{car.model}</h3>

                <div className="grid grid-cols-2 gap-x-4 gap-y-2 mt-4 text-xs text-slate-600">
                    <div className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5" /> {car.bouwjaar}</div>
                    <div className="flex items-center gap-2"><Gauge className="w-3.5 h-3.5" /> {formatKm(car.kilometerstand)}</div>
                    <div className="flex items-center gap-2"><Fuel className="w-3.5 h-3.5" /> {car.brandstof}</div>
                    <div className="flex items-center gap-2"><Cog className="w-3.5 h-3.5" /> {car.transmissie}</div>
                </div>

                <div className="mt-5 pt-4 border-t border-slate-100 flex items-end justify-between">
                    <div>
                        <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-slate-400">Prijs</div>
                        <div className="text-2xl font-black text-[#0E2C4D]">{formatPrice(car.prijs)}</div>
                    </div>
                    <div className="text-[#EC6A0A] text-sm font-bold group-hover:translate-x-1 transition-transform">
                        Bekijk →
                    </div>
                </div>
            </div>
        </Link>
    );
};
